import { HOME_PAGE_ACTIONS } from "../actions/actionTypes";

const initialState = {
  homePageData: null,
  liveStreamData: null,
  epgData: null,
  isHomePageDataLoading: false,
  isLiveStreamDateLoading: false,
  isEpgDataLoading: false
};

export default function(state = initialState, action) {
  const { data } = action.payload || {};
  switch (action.type) {
    case HOME_PAGE_ACTIONS.HOME_PAGE_STRUCTURE._START:
      return {
        ...state,
        isHomePageDataLoading: true
      };

    case HOME_PAGE_ACTIONS.HOME_PAGE_STRUCTURE._SUCCESS:
      return {
        ...state,
        homePageData: data,
        isHomePageDataLoading: false
      };

    case HOME_PAGE_ACTIONS.HOME_PAGE_STRUCTURE._FAILURE:
      return {
        ...state,
        isHomePageDataLoading: false
      };

    case HOME_PAGE_ACTIONS.EPG_DATA._START:
      return {
        ...state,
        epgData: null,
        isEpgDataLoading: true
      };

    case HOME_PAGE_ACTIONS.EPG_DATA._SUCCESS:
      return {
        ...state,
        epgData: data,
        isEpgDataLoading: false,
      };

    case HOME_PAGE_ACTIONS.EPG_DATA._FAILURE:
      return {
        ...state,
        epgData: null,
        isEpgDataLoading: false
      };
    case HOME_PAGE_ACTIONS.LIVE_STREAM._START:
      return {
        ...state,
        isLiveStreamDateLoading: true
      };

    case HOME_PAGE_ACTIONS.LIVE_STREAM._SUCCESS:
      return {
        ...state,
        liveStreamData: data,
        isLiveStreamDateLoading: false
      };

    case HOME_PAGE_ACTIONS.LIVE_STREAM._FAILURE:
      return {
        ...state,
        liveStreamData: null,
        isLiveStreamDateLoading: false
      };
    case HOME_PAGE_ACTIONS.AUTO_RAIL._START:
      let homeDataStart = { ...state.homePageData };
      let updateDataStart = { ...homeDataStart.items[action.payload.index] };
      updateDataStart.specialRail = true;
      homeDataStart.items[action.payload.index] = updateDataStart;
      return {
        ...state,
        homePageData: homeDataStart
      };

    case HOME_PAGE_ACTIONS.AUTO_RAIL._SUCCESS:
      let homeDataSuccess = { ...state.homePageData };
      let updateDataSuccess = {
        ...homeDataSuccess.items[action.payload.index]
      };
      updateDataSuccess.contentList = [
        ...updateDataSuccess.contentList,
        ...data
      ];
      updateDataSuccess.specialRail = false;
      homeDataSuccess.items[action.payload.index] = updateDataSuccess;
      return {
        ...state,
        homePageData: homeDataSuccess
      };

    case HOME_PAGE_ACTIONS.AUTO_RAIL._FAILURE:
      let homeDataFail = { ...state.homePageData };
      let updateDataFail = { ...homeDataFail.items[action.payload.index] };
      updateDataFail.specialRail = false;
      homeDataFail.items[action.payload.index] = updateDataFail;
      return {
        ...state,
        homePageData: homeDataFail
      };

    default:
      return state;
  }
}
